import React from 'react';
import classes from './classes.module.scss';
import PaymentMethod from '../payment_methods_list/payment_method/payment_method';
import { paymentSourcesTheme } from '../config/const';
import AddPaymentMethod from '../payment_methods_list/add_payment_method';
import {
  fromMobileApp, hideEmailAdress, isPGW, isWebView, updatedPurchaseURL
} from '../config/utils';
import  AddApplePayOption  from './apple_pay/add_apple_pay_option';
import { applePayIsSupported, googlePayIsSupported } from '../purchase_details_common/purchase_details_common_utils';
import { PurchaseSvgIcon } from '../sprites';

export const isDefaultePaymentSource = ({ existing }) => {
  if (!existing) return null;
  return existing.find((s) => s.isDefault);
};

const renderAddSourceForKind = ({
  kind, addCreditCard, available, theme, existing, trackPaymentMethodClickedEvent, addSource, loading
}) => {
  if (!available) return null;
  const source = available.find((s) => s.kind === kind);
  if (!source) return null;
  return (
    <AddPaymentMethod
      addSource={ addCreditCard || addSource }
      { ...source }
      key={ source.kind }
      theme={ theme }
      existing={ existing }
      trackPaymentMethodClickedEvent={ trackPaymentMethodClickedEvent }
      loading={ loading }
    />
  );
};

const renderArrowImg = () => {
  let arrowIcon = 'payment_arrow';
  if (isPGW()) arrowIcon = 'payment_arrow_purple';
  return <PurchaseSvgIcon id={ arrowIcon } className={ classes.paymentArrow } size={ 50 } />;
};

const renderPPPaymentOption = ({ context, showPaymentSources, trackPaymentMethodClickedEvent }) => {
  if (!context.paypalBillingAgreementEmail) return null;
  const onPPPaymentOptionClick = () => {
    showPaymentSources();
    trackPaymentMethodClickedEvent('pp');
  };
  return (
    <button
      type="button"
      className={ classes.availableOptionButton }
      onClick={ () => onPPPaymentOptionClick() }
    >
      <div className={ classes.availableOptionButtonTextContainer }>
        <div className={ classes.optionName }>
          <PurchaseSvgIcon id="paypal_icon" className={ classes.paypalImg } />
          { hideEmailAdress(context.paypalBillingAgreementEmail) }
        </div>
        { context.error }
      </div>
      { renderArrowImg() }
    </button>
  );
};

const getDefaulteOrExistingOption = ({ defaulte, existing }) => defaulte || existing[0];

const renderPaymentOption = ({
  existing, kind, renderSource, context, showPaymentSources, options, trackPaymentMethodClickedEvent
}) => {
  const defaulte = isDefaultePaymentSource({ existing });
  if (kind === 'iap') return renderSource(options.find((s) => s.kind === 'iap'));
  if (kind === 'am') return renderSource(options.find((s) => s.kind === 'am'));
  if (kind === 'ap') return renderSource(options.find((s) => s.kind === 'ap'));
  if (kind === 'pp' && !defaulte) return renderPPPaymentOption({ context, showPaymentSources, trackPaymentMethodClickedEvent });
  if (existing && existing.length > 0) {
    return renderSource(getDefaulteOrExistingOption({ defaulte, existing }));
  }
  return null;
};

const renderAddPaymentOptionsForKind = ({
  kind, paymentProcessing, currentPaymentOption, purchaseURL, extraParams, purchaseAmount,
  available, theme, existing, addCreditCard, isPayg, trackPaymentMethodClickedEvent, addSource, loading
}) => {
  if (kind === 'pp') {
    if (isPayg) return null;
    return paymentProcessing(
      currentPaymentOption,
      updatedPurchaseURL({ purchaseURL, extraParams }),
      purchaseAmount,
      () => (renderAddSourceForKind({
        kind: 'pp', available, theme, existing, trackPaymentMethodClickedEvent, loading
      }))
    );
  }
  if (kind === 'gp') {
    return renderAddSourceForKind({
      kind: 'gp', addSource, available, theme, existing, trackPaymentMethodClickedEvent
    });
  }
  return renderAddSourceForKind({
    kind: 'cc', addCreditCard, available, theme, existing, trackPaymentMethodClickedEvent, loading
  });
};

function Option({
  adding,
  extraParams,
  kind,
  errorText,
  context,
  purchaseURL,
  paymentProcessing,
  showPaymentSources,
  addCreditCard,
  loading,
  theme = paymentSourcesTheme.purchase,
  paymentSources,
  options = [],
  changingSource,
  purchaseAmount,
  isPayg,
  trackPaymentMethodClickedEvent,
  paymentMethodListAnalyticsEvents,
  addSource
}) {
  const { existing, available } = paymentSources;
  const currentPaymentOption = { kind, context };

  const renderAddPaymentOptions = () => {
    if (kind === 'pp' && isWebView() && !fromMobileApp)  return  null;
    if (kind === 'pp' && isPayg) return null;
    if (kind === 'gp' && !googlePayIsSupported()) return null;
    if (kind === 'am') {
      if (!applePayIsSupported()) return null;
      return <AddApplePayOption key="AddApplePayOptionAM" topPadding={ 15 } kind={ kind } context={ context } analyticsEvents={ paymentMethodListAnalyticsEvents } loading={ loading } />;
    }
    if (kind === 'ap') {
      if (isPayg || !applePayIsSupported()) return null;
      return (
        <AddApplePayOption key="AddApplePayOptionAP" topPadding={ 15 } kind={ kind } analyticEvents={ paymentMethodListAnalyticsEvents } loading={ loading } />
      );
    }
    return (
      // <div className={ classes.paymentOption }>
      renderAddPaymentOptionsForKind({
        kind,
        paymentProcessing,
        currentPaymentOption,
        purchaseURL,
        extraParams,
        purchaseAmount,
        available,
        theme,
        existing,
        addCreditCard,
        isPayg,
        trackPaymentMethodClickedEvent,
        loading,
        addSource
      })
      // </div>
    );
  };

  const renderSource = (s) => (
    <PaymentMethod
      key={ s.id }
      { ...s }
      onEditSource={ showPaymentSources }
      managePaymentSource={ showPaymentSources }
      theme={ theme }
      loading={ loading }
      options={ options }
      errorText={ errorText }
      changingSource={ changingSource }
      isPayg={ isPayg }
      isPaymentOption
      trackPaymentMethodClickedEvent={ trackPaymentMethodClickedEvent }
    />
  );

  const renderOption = () => {
    if (adding) return renderAddPaymentOptions();
    if (loading) return renderSource({});
    return renderPaymentOption({
      existing, kind, renderSource, context, showPaymentSources, options, trackPaymentMethodClickedEvent
    });
  };

  return renderOption();
}

export default Option;
